export default {
  checkout_plan_configuration: 'Configuration for {planName}',
  checkout_custom_password_hint: 'You can customize your server password.',
  vps_assurance: {
    title: 'Service Assurance',
    item: [
      {
        title: '99.9% Uptime'
      },
      {
        title: '10-min Ready',
        description:
          'Ready time applies to servers in stock. If stock is low, setup may be delayed and could take 24-48 hours.'
      },
      {
        title: 'Easy Control Panel'
      },
      {
        title: '24/7 Engineers'
      }
    ]
  },
  dedicated_assurance: {
    title: 'Service Assurance',
    item: [
      {
        title: '99.9% Uptime'
      },
      {
        title: '2-hr Ready',
        description:
          'Ready time applies to servers in stock. If stock is low, setup may be delayed and could take 24-48 hours.'
      },
      {
        title: 'Easy Control Panel'
      },
      {
        title: '24/7 Engineers'
      }
    ]
  },
  checkout_trial_cycle_unavailable:
    'Free trials are not available for hourly or on-demand billing. Please select a prepaid billing cycle to request a trial.',
  checkout_order_conflict:
    'This purchase conflicts with the original request. Please check your existing orders before submitting again.',
  checkout_order_cancelled: 'This order was cancelled. Submit again to start a new purchase.',
  checkout_order_waiting:
    'Your purchase is awaiting verification. Please check your email or service list for updates.',
  checkout_billing_incomplete:
    'Your billing information is still incomplete. Please update it before submitting again.',
  checkout_no_available_os: 'No operating system is available for this plan and billing type.',
  checkout_no_available_price: 'No price is available for this plan and billing type.',
  checkout_login_status_title: 'Not signed in',
  checkout_login_status_desc: 'Configure your order now. Sign in or create an account to continue.',
  checkout_login_now: 'Log in now',
  checkout_secure_payment: 'Secure checkout · SSL encrypted',
  common: {
    total_entries: 'Total: {0}',
    app: 'Application',
    prod: 'Product',
    vps: 'VPS'
  },
  productType: {
    vm: 'VPS',
    app: 'Application',
    bare_metal: 'Bare Metal Server'
  },
  menu: {
    home: ['Home', 'Dashboard'],
    check: ['Checkout'],
    order_confirm: ['Order Confirm'],
    recharge_credits: ['Recharge Credits'],
    membership: ['Membership'],
    invoice_detail: ['Invoice Details'],
    account_upgrade: ['Account Upgrade'],
    apps: ['Applications', 'View all applications', 'Application List'],
    affiliate: ['Affiliate', 'Affiliate'],
    vps: ['Virtual Servers', 'Virtual Private Server Hosting List', 'Virtual Server List'],
    ssl: ['SSL', 'SSL Digital Certificate Management Service List'],
    domain: ['Domain', 'Domain List'],
    services: ['Other Services', 'SSL, Domain and Kubernetes services'],
    dedicated: ['Dedicated Servers', 'Dedicated Server Hosting List', 'Dedicated Server List'],
    k8s: ['Kubernetes Clusters', 'Kubernetes Cluster List'],
    gpu: ['GPU Servers', 'GPU Server Hosting List', 'GPU Server List'],
    billing: ['Billing', 'Billing Information Management'],
    tickets: ['Customer Support', 'Seek Help from Our Customer Service Team'],
    ticket_detail: ['Ticket Details'],
    dns: ['DNS Management', 'Manage Your DNS Records'],
    all: ['All Products', 'Discover Popular Products'],
    my_services: ['My Services', 'View all your subscribed services'],
    customer_tools: ['Customer Tools', 'Tools for managing your services'],
    app_market: ['APP Marketplace', 'APP Marketplace'],
    // 各产品线 /{service}/ordering 下单浏览页面包屑末级
    ordering: ['Ordering', 'Ordering'],

    products: {
      app: ['Applications', ''],
      vps: ['Virtual Servers', ''],
      gpu: ['GPU Servers', ''],
      dedicated: ['Dedicated Servers', ''],
      k8s: ['Kubernetes Clusters', ''],
      ssl: ['SSL', ''],
      domain: ['Domain', ''],
      softwareApp: ['APP Marketplace', 'APP Marketplace']
    },
    doc: ['Guidance', 'Access Valuable Knowledgebase and Articles'],
    account: ['Account', 'Account Information'],
    account_vertifiy: ['Verification Information'],
    password: ['Change Password'],
    notification: ['Settings'],
    emails: ['Emails', 'View Email Records'],
    logout: ['Log Out'],
    login: ['Log In'],
    sign_up: ['Sign Up'],
    app_overview: ['Overview', 'General settings and information'],
    app_db_user: ['DB & User', 'Manage your databases and users'],
    app_topic_user: ['Topic & User', 'Manage your topics and users'],
    app_site_ssl: ['Site & SSL', 'Manage your websites, DNS, SSL, Domain and URL redirection'],
    app_deployment: ['Deployment', 'Manage your websites, DNS, SSL, Domain and URL redirection'],
    app_security: ['Security', "Manage your {0}'s security setting"],
    app_php_admin: ['phpMyAdmin', 'Manage MySQL/MariaDB'],
    app_domain_dns: ['NS & DNS', 'Manage your Nameservers and DNS records'],
    app_kibana: ['Kibana', 'Manage Elasticsearch'],
    app_parameters: ['Parameters', 'Manage SQL Config File'],
    app_file_manager: ['File Manager', 'Manage the {0} files and folders.'],
    app_shell_ssh: ['Shell/SSH', 'Manage your {0}s via command line interface'],
    app_ftps: [
      'FTPS Server',
      'Encrypt data transfer between your local machine and the {0} server'
    ],
    app_metrics: ['Metrics', 'Check your {0}s’ resource usage'],
    app_snapshots: ['Snapshots', 'Manage data backups and restorations'],
    app_events: ['Events', 'Check the history of {0} management operations'],
    app_guidance: ['Guidance', 'Get step-by-step instructions on {0} management'],
    app_service_info: ['Service Information', 'Check service Details'],
    app_networking: ['Networking', 'Domain Port Management'],
    vps_server: ['Server Management', 'Manage your server'],
    add_software: ['Additional Software', 'Add additional software to your server'],
    billing_information: ['Billing Information'],
    billing_invoices: ['Invoices'],
    billing_payment: ['Payment Methods'],
    billing_credits: ['Credits']
  },
  ordering_page: {
    subtitle: 'Select a plan to get started',
    monthly: 'Monthly',
    yearly: 'Yearly',
    two_year: '2-Year',
    save_20: 'Save 20%',
    save_35: 'Save 35%',
    per_month: '/mo',
    per_hour: '/hr',
    per_year: '/yr',
    per_2_year: '/2yr',
    per_3_year: '/3yr',
    fetch_failed: 'Failed to load plans. Please try again later.'
  },
  ordering_table: {
    plan: 'Plan',
    price: 'Price',
    cpu: 'CPU',
    gpu_model: 'GPU Model',
    memory: 'Memory',
    disk: 'Disk',
    bandwidth: 'Bandwidth',
    backup: 'Backup',
    ip: 'IP',
    location: 'Location',
    popular: 'Popular',
    currently_selected: 'Currently selected:',
    add_to_compare: 'Add to Compare',
    compare_hint: 'Compare up to 3 plans simultaneously',
    select_to_compare_hint: 'Click a {0} to select. You can compare 1 to 3 plans.',
    select_to_compare_title: 'Click to select for comparison',
    plan_name: 'plan name',
    start_comparison: 'Start Comparison',
    comparison_title: 'Plan Comparison',
    compare_limit: 'You can compare up to 3 plans.',
    already_in_compare: 'This plan is already in the compare list.',
    in_compare: 'In Compare',
    pagination_text: 'Showing {0} to {1} of {2} entries',
    showing_plans: '{n} plan | {n} plans',
    compare_empty: 'Select a plan to compare.',
    no_data: 'No data available'
  },
  ordering_compare: {
    plan_description: 'Plan Description',
    supported_os: 'Supported OS',
    setup_fee: 'setup fee'
  },
  user: {
    first_name: 'First Name',
    last_name: 'Last Name',
    country_region: 'Country / Region',
    email: 'Email',
    alt_email: 'Alternative Email',
    state: 'State',
    city: 'City',
    address_1: 'Address',
    address_2: 'Address 2',
    postcode: 'Postcode',
    zipcode: 'ZIP Code',
    phone_cc: 'CC Number',
    phone_number: 'Phone Number',
    address: 'Address',
    company: 'Company',
    web_site: 'Web Site',
    google_plus: 'Google+',
    twitter: 'Twitter',
    facebook: 'Facebook',
    linkedin: 'Linkedin',
    job_description: 'Job Description',
    fax_no: 'Fax Number',
    name: 'Name',
    epp_code: 'EPP Code',
    purpose: 'Purpose',
    category: 'Category'
  },
  attrs: {
    all: 'All',
    subject: 'Subject',
    department: 'Department',
    to: 'TO',
    cc: 'CC',
    time_zone: 'Time Zone',
    instance: 'Instances',
    instance_cpu: 'CPU',
    instance_type: 'Type',
    instance_status: 'Status',
    plan_cpu: 'CPU Cores',
    plan_memory: 'Memory',
    plan_disk: 'Disk',
    plan_backup: 'Backup Storage',
    plan_replica: 'Replica',
    plan_os: 'OS',
    plan_ver: 'Version',
    plan_jdk_ver: 'JDK Version',
    plan_spr_ver: 'Spring Boot Version',
    plan_component: 'Component',
    plan_location: 'Location',
    plan_price: 'Price',
    plan_pricing: 'Pricing',
    plan_actual_price: 'Actual Price',
    plan_due: 'Due date',
    plan_gpu_model: 'GPU Model',
    plan_bandwidth: 'Bandwidth',
    plan_gpu_card: 'GPU Card',
    plan_dedicated_ip: 'Dedicated IP',
    plan_access_port: 'Access Port',
    plan_discount: 'Plan Exclusive Discount',
    billing_cycle: 'Billing Cycle',
    billing_type: 'Billing Type',
    billing_method: 'Payment Method',
    billing_promotion_code: 'Promotion Code',
    billing_sum: 'Summary',
    billing_plan: 'Plan',
    billing_discount: 'Discount | Discount | Discount({n})',
    billing_balance: 'Balance',
    billing_tax: 'Tax',
    billing_total: 'Total',
    plan_setup_fee: 'Plan Setup Fee',
    addon_setup_fee: 'Addon Setup Fee',
    billing_today_total: 'Total',
    billing_sub_total: 'Sub Total',
    billing_credit: 'Credits',
    configuration: 'Configuration',
    app_created: 'Created',
    app_remain: 'Remain',
    app_name: 'Product',
    app_termination: 'Termination Date',
    app_over_due: 'Over Due',
    app_backup_date: 'Backup Date',
    app_backup_size: 'Backup Size',
    app_cancel_reason: 'Reason',
    app_primary_ip: 'Primary IP',
    app_next_due: 'Next Due Date',
    app_reg_date: 'Reg Date',
    app_domain_name: 'Domain Name',
    app_domain_status: 'Domain Status',
    quantity: 'Quantity',
    notes: 'Notes',
    note: 'Note',
    billing_types: ['Prepaid Plans', 'On-Demand']
  },
  button: {
    reply: 'Reply',
    cancelReply: 'Cancel Reply',
    send: 'Send',
    confirm: 'Confirm',
    submit_trial_request: 'Submit Trial Request',
    cancel: 'Cancel',
    update: 'Update',
    submit: 'Submit',
    save: 'Save',
    close: 'Close',
    remove: 'Remove',
    search: 'Search',
    clear: 'Clear',
    billing_cycle: 'Change Billing Cycle',
    billing_type: 'Change Billing Type',
    attach_files: 'Attach files',
    new_app: 'New @.capitalize:common.prod',
    new_gpu: 'Order GPU Server',
    new_linux_vps: 'Order Virtual Server',
    new_gpu_vps: 'Order GPU Server',
    new_dedicated: 'Order Dedicated Server',
    new_k8s: 'Order Kubernetes Cluster',
    new_domain: 'Order a New Domain',
    new_ssl: 'Order New SSL',
    new_ticket: 'Submit Ticket',
    new_feedback: 'Provide Feedback',
    deploy: 'Deploy Now',
    destroy: 'Destroy',
    deploy_on_demand: 'Deploy On-Demand',
    restore: 'Restore',
    details: 'Details',
    rename: 'Rename',
    manage: 'Manage',
    re_deploy: 'Re-deploy',
    pay_now: 'Pay Now',
    order_now: 'Order Now',
    renew: 'Renew',
    check_out: 'Check Out',
    back: 'Back',
    next: 'Next',
    install: 'Install',
    free_trial: 'Free Trial',
    online_chat: 'Online Chat',
    confirm_page: 'Confirm',
    skip: 'Skip',
    out_of_stock: 'Out of stock',
    recharge: 'Add Funds',
    delete_cancellation_request: 'Delete Cancellation Request'
  },
  rule: {
    required: 'Required',
    max_characters: 'Maximum {0} characters',
    min_characters: 'Minimum {0} characters',
    format_error: 'Invalid format, please re-input',
    phone_error: 'Invalid phone number.',
    recharge_limit: 'The amount must be between $2 and $200, with up to 2 decimal places',
    recharge_limit_zh: 'The amount must be between 50CNY and 500CNY, with up to 2 decimal places',
    recharge_limit_auto: 'The amount must be between {0} and {1}, with up to 2 decimal places',
    server_name:
      'A hostname can only contain hyphens (-), period (.), a-z, A-Z, and 0-9, and can not begin and end with a hyphen',
    numberCharacter:
      'A combination of letters, numbers, and symbols (only symbols !@#$%^&*() are supported)',
    noNumOnly: 'Can not only contain numbers',
    cc_email_error: 'One or more emails are invalid',
    c_n_8:
      'Must contain at least 8 characters, including uppercase and lowercase letters and numbers'
  },
  unit: {
    hour: 'hr | hour| hours| {n} hours',
    day: 'day | day(s)',
    month: 'm | month | {n} months',
    year: 'year | {n} year | {n} years',
    currency: '${0}',
    discount: '{0}%off'
  },
  status: {
    cancelled: 'Cancelled',
    deploy_failed: 'Deploy Failed',
    upgrade_failed: 'Upgrade Failed',
    restore_failed: 'Restore Failed',
    addon_failed: 'Addon Failed',
    process: 'Processing',
    active: 'Active',
    pending: 'Pending',
    suspended: 'Suspended',
    pending_activation: 'Pending Activation',
    pending_removal: 'Pending Removal',
    addon_cancelled: 'Cancelled',
    unconfirmed: 'Unconfirmed'
  },
  runningStatus: {
    running: 'Running',
    failed: 'Failed',
    start_up: 'Startup',
    shut_off: 'Shut Off',
    paused: 'Paused',
    error: 'Error'
  },
  ipStatus: {
    pending: 'Pending',
    adding: 'Adding',
    deleting: 'Deleting',
    active: 'Active',
    addition_failed: 'AdditionFailed',
    deletion_failed: 'DeletionFailed',
    addition_timeout: 'AdditionTimeout',
    deletion_timeout: 'DeletionTimeout'
  },
  paidStatus: {
    processing: 'Processing',
    unpaid: 'Unpaid',
    paid: 'Paid',
    cancelled: 'Cancelled',
    fully_refunded: 'Fully Refunded',
    partially_refunded: 'Partially Refunded',
    partially_paid: 'Partially Paid',
    draft: 'Draft',
    charged_back: 'Charged Back'
  },
  affStatus: {
    pending: 'Pending',
    invalid: 'Invalid',
    available: 'Available',
    withdrawing: 'Withdrawing',
    withdrawn: 'Withdrawn'
  },
  commissionStatus: {
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    cancelled: 'Cancelled'
  },
  payment_method: {
    stripe_alipay: 'AliPay',
    ach_card: 'Bank Account',
    credit_card: 'Credit Card',
    paypal: 'PayPal',
    credit: 'Credit Applied',
    ali_pay: 'AliPay',
    wechat_pay: 'WeChat Pay',
    contact_tip: 'If you have any questions, please {link}.',
    contact_us: 'contact us'
  },
  cancelReason: {
    overdue: 'Overdue On Payment',
    cancel_req: 'Cancellation Request',
    fail_verify: 'Failed Identity Verification',
    cancel_agent: 'Cancelled by Agent',
    suspend_agent: 'Suspended by Agent',
    closed: 'Account Closed',
    resource_abuse: 'Resource Abuse',
    resource_overflow: 'Resource Overflow'
  },
  departments: {
    billing: 'Billing Department',
    sales: 'Sales Department',
    support: 'Support Department',
    operation: 'Operation Department'
  },
  message: {
    install_tips: [
      'It may take some time to finish.',
      'Payment successful and the system is processing your request, please wait patiently.'
    ],
    success_common: ['Operation completed successfully.'],
    error_common: ['Sorry! Something went wrong. Please contact us by ticket.'],
    error_deploy: ['Deploy failed. Please wait for manual deployment. It may take 2-4 hours.'],
    search_empty: [
      "It looks like there aren't matches for your search. {us} if you would like us to provide service for the product you searched.",
      'Contact us'
    ],
    change_billing_cycle: [
      'The billing cycle was updated successfully',
      'The billing cycle update failed ! Please try again later.'
    ],
    change_name: [
      'Your {name} was renamed successfully.',
      'Oops, {name} renaming failed, please contact us at {email} for this issue.'
    ],
    cancel_app: [
      'The cancellation request of your product has been deleted.',
      'Oops, your service cancellation failed. You can reach us at {email} for this issue.'
    ],
    paypal: [
      'After you update, the future recurring amount will be changed, followed by your PayPal subscription cancellation. If you still need automatic payment through PayPal, please click “PayPal Subscription” when you renew.',
      'Subscribed via PayPal'
    ]
  }
}
